export default ({
  group: {
    site: {
      id,
    },
  },
}) => id || 'not-set'
